const OtherS = [
	{
		id:1,
		title:"PROPOSALS",
		fee:'3,500',
		description:"ENGAGEMENT & RECEPTION ONLY",
		detail1: 'Drone',
		detail2: '2 Cameras',
		detail3: '1 min. 20 sec. and above trailer'
	}
]
export default OtherS;